<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { InfoCircleIcon } from "@gohighlevel/ghl-icons/24/outline";
import { UIInputNumber, UITooltip } from "@gohighlevel/ghl-ui";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
defineProps({
  label: {
    type: String,
    default: "",
  },
  value: {
    type: Number || String,
    default: 0,
  },
  isLabelSmall: {
    type: Boolean,
    default: false,
  },
  max: {
    type: Number,
    default: 200,
  },
  min: {
    type: Number,
    default: 0,
  },
  tooltipMessage: {
    type: String,
    default: "",
  },
});

const store = useAppStore();
const emit = defineEmits(["update:value"]);
const handleSetCount = (val: string) => emit("update:value", parseFloat(val) || 0);
</script>
<template>
  <div :class="isLabelSmall ? 'mb-2' : 'mb-2 grid grid-cols-2'">
    <label
      for="text-input"
      :class="
        isLabelSmall
          ? 'm-0 block text-xs font-normal text-gray-700'
          : 'my-auto text-sm font-normal text-gray-700'
      "
    >
      {{ label }}
      <UITooltip
        v-if="tooltipMessage"
        :style="{ maxWidth: '300px' }"
        trigger="hover"
        placement="top"
      >
        <template #trigger>
          <InfoCircleIcon class="ml-1 h-4 w-4 text-gray-400"></InfoCircleIcon>
        </template>
        {{ tooltipMessage }}
      </UITooltip>
    </label>
    <div :class="isLabelSmall ? 'relative mt-1 rounded-md shadow-sm' : 'd-inline pixel-count'">
      <UIInputNumber
        id="text-input"
        :show-button="false"
        class="input-field"
        :min="min"
        :max="max"
        :value="value"
        @change="handleSetCount"
        @blur="store.addToHistory"
      >
        <template #suffix> {{ t("common.px") }} </template>
      </UIInputNumber>
    </div>
  </div>
</template>

<style lang="css" scoped>
.input-field {
  font-size: 12px !important;
}
</style>
